import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { apiClient } from '../../../helpers/api_helper';
import { BarChartData } from '../../../common/data/analytics';
import { Spinner } from "reactstrap";

const Markers = () => {
  const [barChartData, setBarChartData] = useState<BarChartData | null>();

  useEffect(() => {
    fetchChartData();
  }, []);

  const fetchChartData = async () => {
    try {
      const response = await apiClient.get('/analytics/actividades-por-departamento/');
      setBarChartData(response.data ? response.data : response);
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }
  };

  var options = {
    chart: {
      toolbar: {
        show: !1,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !0,
      },
    },
    colors: barChartData?.colors,
    xaxis: {
      show: false, // Hide x-axis
    },
    yaxis: {
      labels: {
        formatter: function (val: any) {
          return val;
        },
      },
    },
    grid: {
      show: true, // Remove grid
    },
    dataLabels: {
      formatter: function (val: any, opt: any) {
        var goals =
          opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex].goals;

        return val;
      },
    },
  };

  return (
    barChartData ? (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={barChartData?.series}
        type="bar"
        height={350}
      />
    </React.Fragment>
    ):(<Spinner color="primary" />)
  );
};

export default Markers;
